// export const Url = "https://devapi.titegypt.org";
// export const Url = "https://nilecruisesapi.titegypt.org";
// export const Url = "https://nilecruisesapi.titegypt.org";
// export const Url = "https://api.nilecabins.com";
export const Url = "https://api.nilestar.co";
